import { addCss } from '@zk/framework-vue';
import { createDriver, resetDriversByNS } from '@zk/framework-vue';
import { OverseasGuideConfig } from './overseasDriverConfig';
import Driver from 'driver.js';
const SCOPED_NAME = 'overseas-guide-driver';
const CLOSE_ICON_CLASS = 'zk-overseas-guider-close-icon';
import { OverseasGuideDriverConfig } from './overseasDriverConfig';
import { waitGetAny } from '@zk/framework-vue';
import { sleep } from '@/utils';
import Vue from 'vue';
import eventBus from '@/plugins/eventBus';
const insertCurrentCss = (options: any) => {
  return addCss(options.scopedName || SCOPED_NAME, (name: string) => {
    return `
  body * {
    transform-box: view-box;
  }

  [class*=USE_SCREEN_RECORD] .el-drawer__wrapper {
    position: absolute !important;
  }
  [class*=CHECK_SCREEN_RECORD] .el-drawer__wrapper {
    position: absolute !important;
  }
  [class*= USE_SCREEN_RECORD]  .zk-issue-detail-field-description .zk-editor {
    height: 600px;
  }
  .${name} .zk-template-explain-dialog {
    z-index: 99999999 !important;
  }
  .${name} .zk-project-dialog {
    z-index: 99999999 !important;
  }
  .${name} div[id^=tippy], .${name} .zk-work-flow-status-edit__edit-popover, .${name} .zk-issue-type-create__edit-popover {
    z-index: 9999999991 !important;
  }
  .${name} .el-dropdown-menu, .${name} .zk-invite-member-select__suggest-popper {
    z-index: 9999999991 !important;
  }
  .${name} .zk-edit-sprint-dialog{
    z-index: 999999999 !important;
  }
  .${name} .zk-select-template-dialog.driver-fix-stacking {
    position: absolute !important;
  }
  .${name} #guide-create-dashboard,.zk-top-nav__navs .zk-top-nav__nav-name--project-worktype.driver-highlighted-element, .zk-project-setting-issue-type-list__row-operate >span:nth-child(2) .el-link--inner.driver-highlighted-element{
    background: #fff !important;
  }
  // .${name} .zk-left-menu .zk-left-menu-item[data-menu="dashboard"] .zk-left-menu-item__content{
  //   background: transparent;
  // }

  .${name} .driver-content-filter-task{
    font-size: 18px;
    line-height: 26px;
  }
  .${name} .driver-content-filter-task img {
    margin-top: 12px;
    border-radius: 6px;
    float: left;
    width: 280px;
    height: auto;
  }
  .${name} #master-container{
    transform: scale(1);
  }
  #driver-highlighted-element-stage{
    background-color: transparent !important;
  }
  .${name}#driver-popover-item .driver-popover-tip.left {
    border-color: transparent rgb(111, 109, 237) transparent transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.top {
    border-color: transparent transparent rgb(111, 109, 237) transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.bottom {
    border-color: rgb(111, 109, 237) transparent  transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.right {
    border-color: transparent transparent  transparent rgb(111, 109, 237);
  }
  .guide-popover-left{
    transform: translateX(-8px);
  }
  .guide-popover-right{
    transform: translateX(8px);
  }
  .guide-popover-top{
    transform: translateY(-8px);
  }
  .guide-popover-bottom{
    transform: translateY(8px);
  }
  ${options.className}.driver-highlighted-element {
    border: 2px solid var(--primary-color);
    animation: 3s infinite linear scaleBoxShadow;
    transform: translateX(-2px);
    border-radius: 6px;
  }
  .${name} .zk-float-add-btn.driver-highlighted-element{
    border-radius: 50% !important;
  }
  .zk-confirm-dropdown.driver-highlighted-element{
    // padding: 5px 0 !important;
    // margin-top: -8px !important;
    // margin-bottom: 3px !important;
    background: #fff;
    border-radius: 6px;
    margin-top: -2px !important;;
    margin-bottom: 8px !important;;
  }
  .zk-top-nav__navs ${options.className}.driver-highlighted-element {
    background: #fff;
  }
  .${name} .zk-air-table .zk-common-filter-top-index__add-filter .iconicon_tianjia.driver-highlighted-element{
    background: #fff;
    border-radius: 6px;
  }
  ${options.className}.top-nav-automation.driver-highlighted-element{
    transform: translateX(0px);
    background: #fff;
  }
  div.project-list-drawer-create.driver-highlighted-element{
    background: #fff;
    border-radius: 6px !important;
  }
  div.zk-float-add-btn__wrapper.driver-highlighted-element{
    background: #fff;
    transform: translateX(2px) translateY(2px);
  }
  div.zk-left-aside__invite.driver-highlighted-element{
    border-radius: 6px!important;
    transform: none;
  }
  div#driver-popover-item.${name} {
    padding: var(--m-large);
    min-width: 288px;
    max-width: 340px;
    border-radius: 6px;
    background: rgba(111, 109, 237, 1);
    padding: 12px 16px 16px 24px;
    box-shadow: 0px 6px 12px 0px rgba(96, 97, 132, 0.16);
    color: #fff;
  }
  div#driver-popover-item.${name}::before {
    content: '';
    border-radius: 6px;
    width: 60px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 0;
    background: inherit;
    z-index: -1;
  }
  div#driver-popover-item.${name} .driver-popover-footer {
    padding: 0;
    margin-top:24px;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-btn{
    display: none;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-only-btn{
    display: inline-block;
  }
  div#driver-popover-item.${name} .driver-popover-footer button {
    border-radius: var(--radius-mini);
    border: 0px solid #fff;
    background: var(--primary-color);
    color: #FFF ;
    padding: 4px 16px;
    font-size: 12px !important;
    height: 32px;
    text-shadow: initial !important;
    box-shadow: 0px 2px 10px 2px rgba(99, 96, 230, 0.16);
    border-radius: 16px;
  }
  div#driver-popover-item.${name} .driver-popover-footer button:hover {
    color: var(--font-color-5) !important;
    background-color: var(--brand-color-6);
    border-color: var(--brand-color-6);
  }
  div#driver-popover-item.${name}  .driver-popover-title {
    line-height: 24px;
    font-size: 13px;
    color: rgba(210, 203, 250, 1) !important;
    padding-right: 20px;
  }

  div#driver-popover-item.${name}  .driver-popover-title .${CLOSE_ICON_CLASS} {
    position: absolute;
    top: -2px;
    right: -8px;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }

  div#driver-popover-item.${name}  .driver-popover-title .${CLOSE_ICON_CLASS}:hover {
    opacity: 0.8;
  }

  div#driver-popover-item.${name} .driver-popover-description {
    font-weight: bold !important;
    color: #fff;
    font-size: 14px;
  }
  .guide-popover-automation .driver-popover-tip{
    right: 10px !important;
  }
  .guide-popover-inviteMember .driver-popover-tip{
    left: 15px !important;
  }
  @keyframes scaleBoxShadow{
    0%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    25%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    50%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    75%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    100%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
  }`;
  }, options);
};

export class OverseasGuideDriver {

  options: OverseasGuideConfig;

  currentStep: number = 0;

  driver: Driver | undefined;

  el: Element | undefined;

  scopedName: string = SCOPED_NAME;

  observer: ResizeObserver | undefined;

  vueInstance: Vue;

  pid: number | undefined;

  constructor(key: string, instance: Vue, pid?: number) {
    this.options = OverseasGuideDriverConfig[key];
    this.currentStep = 0;
    this.pid = pid;
    this.vueInstance = instance;
  }

  initObserver(el: HTMLElement) {
    this.observer = new ResizeObserver(() => {
      if (this.driver && !this.isElementVisible(el)){
        this.stop();
        eventBus.$emit('overseasGuide:close');
      }
      console.log('Size changed');
    });
    this.observer.observe(el);
  }

  private onDocumentClick = (e: MouseEvent) =>{
    const closeIcon = document.querySelector(`.${CLOSE_ICON_CLASS}`);
    if (closeIcon?.contains(e.target as Node)){
      this.stop();
      eventBus.$emit('overseasGuide:close');
    }
  }

  private initEvent() {
    document.addEventListener('click', this.onDocumentClick);
  }

  get currentStepConfig() {
    return this.options.steps[this.currentStep];
  }

  private get isLastStep() {
    return this.currentStep === this.options.steps.length - 1;
  }

  private next() {
    this.currentStep++;
    this.start();
  }

  private onHighlightClick = async () => {
    console.log('click', this);
    if (this.currentStepConfig.highlightClickStop === false){
      return;
    }
    this.toNextStep();
  }

  private transformI18nText(text: string) {
    const vueInstance = this.vueInstance;
    return text.replace(/t\((.*?)\)/g, function(match: string, p1: string) {
      return vueInstance.$t(p1) as string;
    });
  }

  async toNextStep(){
    this.stop();
    const { afterEnd } = this.currentStepConfig;
    if (afterEnd) {
      await afterEnd();
    }
    if (this.isLastStep) {
      eventBus.$emit('overseasGuide:close');
      // const { key, triggerFinish } = this.options;
      // if (triggerFinish) {
      //   setTimeout(
      //     () => {
      //       this.vueInstance.$store.dispatch('overseasGuide/finishTask', key);
      //     }, 200
      //   );
      // }
    } else {
      this.next();
    }
  }

  private isElementVisible(el: HTMLElement | null) {
    return el && el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  async start() {
    if (!this.options?.steps){
      return;
    }
    if (!this.currentStepConfig){
      return;
    }
    const { selector, routePath, wait, maxWait, popover, showCloseIcon, notFoundTip } = this.currentStepConfig;
    let ele: HTMLElement | null = document.querySelector(selector);
    if (routePath && (!this.isElementVisible(ele) && this.vueInstance.$route.path !== routePath) || (this.pid !== this.vueInstance.$store.state.app.currentProject)){
      let query: any = {};
      if (this.vueInstance.$route.path === routePath){
        query = { ...this.vueInstance.$route.query };
      }
      if (this.pid){
        query.pid = this.pid;
      }
      this.vueInstance.$router.push({ path: routePath, query });
      await sleep(500);
    }
    if (wait){
      await sleep(wait);
    }
    if (!ele || !this.isElementVisible(ele)){
      try {
        ele = await waitGetAny(() => {
          const el: HTMLElement | null = document.querySelector(selector);
          return this.isElementVisible(el) ? el : null;
        }, { interval: 50, timeout: maxWait || 5000 });
      } catch (error) {
        console.error('未找到对应的元素');
        if (notFoundTip){
          this.vueInstance.$message.warning(this.transformI18nText(<string>notFoundTip));
        }
        return;
      }
    }
    if (!ele) {
      return;
    }
    this.el = ele;
    this.initObserver(ele);
    this.scopedName = `${this.options.key}${this.currentStep}`;
    const currentCss = insertCurrentCss({ auto: true, className: selector, scopedName: this.scopedName });
    this.driver = createDriver(SCOPED_NAME, {
      className: currentCss,
      allowClose: false,
      opacity: 0.2,
      keyboardControl: false,
      showButtons: false,
      onHighlightStarted: async () => {
        ele && ele.addEventListener('click', this.onHighlightClick, true);
      }
    });
    this.driver.highlight({
      element: selector,
      popover: {
        ...popover,
        title: !showCloseIcon ? this.transformI18nText(<string>popover.title) : `${this.transformI18nText(<string>popover.title)}<em class="zkicon iconqingkongtubiao ${CLOSE_ICON_CLASS}"></em>`,
        description: this.transformI18nText(<string>popover.description)
      }
    });
    this.initEvent();
    if (this.currentStep === 0) {
      eventBus.$emit('overseasGuide:start');
    }
  }

  stop() {
    if (this.driver){
      this.driver.reset();
      this.driver = undefined;
    }
    resetDriversByNS(this.scopedName, true);
    this.observer?.disconnect();
    this.observer = undefined;
    this.el?.removeEventListener('click', this.onHighlightClick, true);
    this.el = undefined;
    document.removeEventListener('click', this.onDocumentClick);
  }
}
